import { render } from "./ItemCategoriaNovo.vue?vue&type=template&id=77fdeaeb&scoped=true"
import script from "./ItemCategoriaNovo.vue?vue&type=script&lang=js"
export * from "./ItemCategoriaNovo.vue?vue&type=script&lang=js"

import "./ItemCategoriaNovo.vue?vue&type=style&index=0&id=77fdeaeb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fdeaeb"]])

export default __exports__